export default __webpack_public_path__ + "static/media/Cell-culture-bag-1.6ffb1a49.jpg";